import script from "./Registration.vue?vue&type=script&lang=ts&setup=true"
export * from "./Registration.vue?vue&type=script&lang=ts&setup=true"

import "./Registration.vue?vue&type=style&index=0&id=4dd24bfd&lang=less"

const __exports__ = script;

export default __exports__